import { formatDate, formatPKR } from '../format';
import type { DefaultFields } from '../types';

export interface DefaultFieldsTableProps {
  fields: DefaultFields;
}

// Canonical 9-row default-fields readout used by every bucket view. Mirrors
// the visual style of the legacy `TerminalReadout` block in DetailPanel.tsx.
export function DefaultFieldsTable({ fields }: DefaultFieldsTableProps) {
  const rows: Array<{ label: string; value: string }> = [
    { label: 'Vendor', value: fields.vendor ?? '—' },
    { label: 'OCR vendor', value: fields.ocr_vendor ?? '—' },
    { label: 'Invoice no.', value: fields.invoice_no ?? '—' },
    { label: 'Invoice date', value: formatDate(fields.invoice_date ?? null) },
    { label: 'FBR number', value: fields.fbr_number ?? '—' },
    { label: 'NTN', value: fields.ntn ?? '—' },
    { label: 'PO #', value: fields.po_no ?? '—' },
    { label: 'GRN #', value: fields.grn_no ?? '—' },
    { label: 'Subtotal', value: formatPKR(fields.subtotal_before_tax) },
    { label: 'Tax amount', value: formatPKR(fields.tax_amount) },
    { label: 'Gross amount', value: formatPKR(fields.gross_amount) },
  ];

  return (
    <section className="rounded-lg border border-neutral-200 bg-neutral-0 p-16">
      <p className="mb-12 text-xs font-semibold uppercase tracking-wide text-neutral-500">
        Invoice fields
      </p>
      <div className="grid gap-12 tablet:grid-cols-3">
        {rows.map((row) => (
          <div
            key={row.label}
            className="rounded-md border border-neutral-200 bg-neutral-0 p-12"
          >
            <p className="text-xs font-medium uppercase tracking-wide text-neutral-500">
              {row.label}
            </p>
            <p
              className="mt-4 truncate text-sm font-medium text-neutral-900"
              title={row.value}
            >
              {row.value || '—'}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
